export enum TipoCertificadoEnum {

  PKCS12="PKCS12"

}
